import * as Yup from 'yup';
import { DictionaryBoilerType } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryBoilerType>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
